import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { 
    MatButtonModule, 
    MatIconModule, 
    MatMenuModule, 
    MatToolbarModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    MatTooltipModule
} from '@angular/material';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';

import { AuthService } from "../../../core/auth.service";
import { ProfileFormDialogComponent } from './profile-form/profile-form.component';
import { UploadProfileImgComponent } from './profile-form/upload-profile-img/upload-profile-img.component';

import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxPicaModule } from 'ngx-pica';

@NgModule({
    declarations: [
        ToolbarComponent,
        ProfileFormDialogComponent,
        UploadProfileImgComponent
    ],
    imports     : [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatDialogModule,
        MatInputModule,
        MatSnackBarModule,
        MatTooltipModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,

        ImageCropperModule,
        NgxPicaModule
    ],
    providers: [
        AuthService,
        // UploadProfileImgService
    ],
    entryComponents: [
        ProfileFormDialogComponent
    ],
    exports     : [
        ToolbarComponent
    ]
})
export class ToolbarModule
{
}
